/* eslint-disable prefer-destructuring,func-names,react/prop-types,prefer-arrow-callback */
import _ from 'lodash';
import React from 'react';

import Button from '../../views/StyledButton';
import Clamper from '../../views/ContentWidthClamper';
import ButtonList from '../../views/ButtonList';
import PageFrame from '../../views/PageFrame';
import StyledTable from '../../views/StyledTable';
import SelectableHeader from '../../views/SelectableHeader';

import { Text } from './../../views/typography';
import { MODEL_SPOTTING_GROUP_IDENTITY } from '../../store/models/SpottingGroup/spottingGroupConstants';
import HeadlineBreadcrumbList from '../../views/HeadlineBreadcrumbList';
import DeleteCheckedButton from '../../views/DeleteCheckedButton';

export default (bottle) => {
  bottle.factory('spottingGroupDrawerTitle', () => (editingItem) => {
    if (!editingItem) {
      return 'New Group';
    }
    return `Editing ${_.upperFirst(editingItem.groupType)} 
      "${editingItem[MODEL_SPOTTING_GROUP_IDENTITY]}"`;
  });

  // eslint-disable-next-line prefer-arrow-callback
  bottle.factory('SpottingGroupView', function () {
    return ({
      data, config, columns, title, intro, goNew, checkLength,
      rowSelection, deleteSelected, goHome, isLoading, onChange,
    }) => (
      <React.Fragment>
        <PageFrame>
          <Clamper>
            <HeadlineBreadcrumbList>
              {[
                { onClick: goHome, text: 'Home' },
                title,
              ]}
            </HeadlineBreadcrumbList>
            {intro && <Text>{intro}</Text>}

            <SelectableHeader dataHidden={!checkLength} popLast>
              <DeleteCheckedButton
                onClick={deleteSelected}
              >Delete Checked
              </DeleteCheckedButton>
              <ButtonList compact line={false} style={({ flex: 1 })}>
                <Button type="primary" icon="plus" onClick={goNew}>New Spotting Group</Button>
              </ButtonList>
            </SelectableHeader>
            <StyledTable
              {...config}
              hightlightSelectable={checkLength}
              columns={columns}
              onChange={onChange}
              rowSelection={rowSelection}
              dataSource={data}
              loading={isLoading}
              rowKey={MODEL_SPOTTING_GROUP_IDENTITY}
              pagination={false}
            />
          </Clamper>
        </PageFrame>
      </React.Fragment>
    );
  });
};
